
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compete-terms",
      function () {
        return require("private-next-pages/compete-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compete-terms"])
      });
    }
  